import React, { useEffect, useState } from 'react'
import CreateRealizationModal from './components/createRealizationModal';
import axios from 'axios';

export default function RealizationsPanel() {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [selectedRealization, setSelectedRealization] = useState(null);
  const [realizations, setRealizations] = useState([]);

  const onClose = () => {
    setShowCreateModal(false);
    setSelectedRealization(null);
    console.log('Modal zamknięty');
  }

  const loadData = async () => {
    try {
      const response = await axios.get('https://megamont.pl/api/realizations');
      console.log('Załadowane realizacje:', response.data);
      setRealizations(response.data);
    } catch (error) {
      console.error('Błąd podczas ładowania realizacji:', error);
    }
  };

  // NOWA FUNKCJA: Usuwanie realizacji
  const handleDelete = async (id) => {
    // Potwierdzenie usunięcia
    if (window.confirm("Czy na pewno chcesz usunąć tę realizację? Tej operacji nie można cofnąć.")) {
      try {
        const response = await axios.delete(`https://megamont.pl/api/realizations/${id}`);
        
        if (response.status === 200) {
          alert("Realizacja została usunięta.");
          loadData(); // Odświeżenie listy po usunięciu
        }
      } catch (error) {
        console.error('Błąd podczas usuwania realizacji:', error);
        alert("Wystąpił błąd podczas usuwania. Spróbuj ponownie.");
      }
    }
  };

  useEffect(() => {
    loadData()
  }, []);

  return (
    <div className='main RealizationsPanel'>
        <h2 className="fw-bold border-bottom pb-2 mb-3 gradient-text">
          Realizacje
        </h2>
        <section className="mt-4">
          <div className="row">
            <div className="col-12">
              <div className="d-flex justify-content-between align-items-center p-0 mb-1">
                <h3>Lista Realizacji</h3>
                <button className="btn btn-custom" onClick={(e)=>setShowCreateModal(true)}>Dodaj Nową Realizację</button>
              </div>
            </div>
            <div className="col-12 p-0 m-0 shadow">
              <table className='Table'>
                <thead> 
                  <tr>
                    <th>ID</th>
                    <th>Nazwa Realizacji</th>
                    <th>Data Dodania</th>
                    <th>Akcje</th>
                  </tr>
                </thead>
                <tbody>
                  {realizations.length > 0 ? realizations.map((realization, index) => (
                    <tr key={index}>
                      <td>{realization.id}</td>
                      <td>{realization.name}</td>
                      <td>{new Date(realization.date).toLocaleDateString()}</td>
                      <td>
                        <button 
                          className="btn btn-sm btn-primary me-2" 
                          onClick={(e)=>{setSelectedRealization(realization); setShowCreateModal(true);}}
                        >
                          Edytuj
                        </button>
                        {/* Zaktualizowany przycisk usuwania */}
                        <button 
                          className="btn btn-sm btn-danger" 
                          onClick={() => handleDelete(realization.id)}
                        >
                          Usuń
                        </button>
                      </td>
                    </tr>
                  )) : (
                    <tr>
                      <td colSpan="4" className="text-center">Brak realizacji do wyświetlenia.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </section>
        {showCreateModal && (
          selectedRealization ? (
            <CreateRealizationModal Realization={selectedRealization} onClose={onClose} refreshData={loadData} />
          ) : (
            <CreateRealizationModal onClose={onClose} refreshData={loadData}/>
          )
        )}
    </div>
  )
}